"use client"

import { useEffect } from "react"
import "./Alert.css"

const Alert = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
    }, 5000)

    return () => clearTimeout(timer)
  }, [onClose])

  return (
    <div className={`alert alert-${type}`}>
      <p>{message}</p>
      <button className="close-btn" onClick={onClose}>
        &times;
      </button>
    </div>
  )
}

export default Alert

